import env from './appEnv'
import { isPrivateCloud } from './utils'

/**
 * Will output the correct public Sketch website
 * depending on the environment. For PAAS envs,
 * https://sketch.com will be used.
 *
 * @example
 * <Link href={`${SKETCH_WEBSITE}/home`}
 */
export const SKETCH_WEBSITE = isPrivateCloud
  ? 'https://sketch.com'
  : env.sketch_website

/**
 * Will output the correct base Sketch domain
 * depending on the environment
 *
 * @example
 * <Link href={`${SKETCH_ENV_URL}/c`}
 */
export const SKETCH_ENV_URL = env.sketch_website
